/* global FileReader:true */
/* global FormData:true */
/* global window:true */

import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';

import TextAreaGroup from '../elements/TextAreaGroup';

const TITLE = 'Invite';

class InvitePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            emails: ''
        };
    }

    componentDidMount() {
        const { actions } = this.props;

       // set breadcrumb
        actions.setBreadcrumb([{ title: TITLE }]);

       // log analytics
        ReactGA.pageview(window.location.pathname);
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const { actions } = this.props;
        const { emails } = this.state;

        const body = new FormData();
        body.append('emails', emails);

        actions.inviteUsersRequest(body);
    };

    render() {
        const { profile } = this.props;

        return (
            <div className="register-wrapper index-1">
                <Helmet title={TITLE} />
                <div className="section-name index-1 container">
                    <div className="col-md-12 resources-title">
                        <h1>{TITLE}</h1>
                        <div className="sep" />
                    </div>
                </div>

                <div className="portfolio-main container" style={{ marginTop: '50px' }}>
                    <div className="row">
                        <div className="col-md-6">
                            <p>We believe that enterprise learning doesn’t have to end in the classroom. We are giving all parents of children in the United Kingdom the opportunity to access our enterprise portal.</p><br />
                            <p>To send portal access to other parents, just enter their email address here.</p><br />
                            <p>Every email address you add will be automatically sent the portal link on your behalf, along with a unique username and password, so they are able to access the portal.</p><br />
                            <p>In line with our privacy policy, we never share email addresses with any third party.</p>
                        </div>
                        <div className="col-md-6">
                            <form className="ui large form" onSubmit={this.handleSubmit}>
                                <TextAreaGroup
                                    id="emails"
                                    name="emails"
                                    label="Add one email address per line"
                                    type="emails"
                                    value={this.state.emails}
                                    onChange={e => this.setState({ emails: e.target.value })} />
                                <button
                                    className="ui large primary button"
                                    style={{ backgroundColor: '#ff6e32' }}
                                    disabled={profile.isFetching}>
                                    Submit
                                </button>
                            </form>
                            <br />
                            <p style={{ fontSize: '11px' }}>Once clicking submit, it may take a few moments to complete your request. <br />
                                Please do not leave or refresh this page until you have received confirmation that your upload was successful.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

InvitePage.propTypes = {
    actions: PropTypes.object,
    profile: PropTypes.object
};

export default InvitePage;



/** WEBPACK FOOTER **
 ** ./src/pages/InvitePage.js
 **/